import { observable } from 'mobx';
import ReportsService from '../services/Reports.service';

class ReportsStore {
  reports = observable([]);
  initialFetchDone = observable.box(false);

  async fetchReports() {
    if (this.initialFetchDone.get()) {
      return this.reports;
    }

    try {
      const items = await ReportsService.fetchReports();
      const simplifiedItems = await ReportsService.fetchSimplifiedReports();

      if (items.isEmpty) {
        return null;
      }
      this.initialFetchDone.set(true);

      const allReports = [...items.items];
      if (!simplifiedItems.isEmpty) {
        allReports.push(...simplifiedItems.items);
      }

      this.reports.push(...allReports.sort(this.compareFn.bind(this)));

      return this.reports;
    } catch (e) {
      console.error('Failed to fetch Reports data', e);
      return null;
    }
  }

  compareFn(a, b) {
    const a_hash = a ? this.hashFn(a) : 0;
    const b_hash = b ? this.hashFn(b) : 0;

    return b_hash - a_hash;
  }

  hashFn(report) {
    return Number.parseInt(
      `${report.year}${this.quarterToNumber(report.quarter)}`,
      10
    );
  }

  quarterToNumber(value) {
    switch (value.toLowerCase()) {
      case '1':
        return 1;
      case '2':
        return 2;
      case '3':
        return 3;
      case '4':
        return 4;
      case 'roczny':
        return 6;
      default:
        return 0;
    }
  }

  getReportsByCategory(criteria) {
    if (!criteria.period) {
      return this.reports;
    }

    return criteria.period.length
      ? this.reports.filter(report =>
          criteria.period[0].includes(report.period)
        )
      : this.reports.filter(el => el.year === criteria.year);
  }

  isLoaded() {
    return this.initialFetchDone.get();
  }
}
export default new ReportsStore();



// WEBPACK FOOTER //
// ./src/stores/Reports.store.js